import { useState } from 'react';
import { BuffOrDebuff, WarbandMemberDTO } from '../types';
import { StatModifier, getStatModifiers } from '../utils/splitStats';
import { getSplitStatValue } from '../utils/splitStats';

export interface StatPopoverState {
  anchor: HTMLElement;
  label: string;
  base: number;
  adjusted: number;
  modifiers: StatModifier[];
}

export const useStatPopover = () => {
  const [statPopover, setStatPopover] = useState<StatPopoverState | null>(null);

  const openStatPopover = (
    e: React.MouseEvent<HTMLElement>,
    member: WarbandMemberDTO,
    stat: string,
    label: string,
    base: number,
    warbandBuffs?: BuffOrDebuff[]
  ) => {
    const modifiers = getStatModifiers(member, stat, base, warbandBuffs);
    const adjusted = getSplitStatValue(member, stat, base, warbandBuffs);
    setStatPopover({
      anchor: e.currentTarget,
      label,
      base,
      adjusted,
      modifiers,
    });
  };

  const closeStatPopover = () => {
    setStatPopover(null);
  };

  return {
    statPopover,
    openStatPopover,
    closeStatPopover,
  };
};
